import axios from "axios";
import authHeader from "../services/AuthHeader";
// import router from "@/router"; 

const server = axios.create({
  // baseURL: "http://192.168.219.200:9001",
  // baseURL: "https://edata.dvi-ind.com",
  // baseURL: "http://192.168.10.10:9000",
  // 배포별 주소는 .env.<mode> 의 VUE_APP_API_BASE 로 바꾼다 (예: 데모 서버는 "/api")
  baseURL: process.env.VUE_APP_API_BASE || "https://demo.dgelec.kr",
  // baseURL: "http://192.168.1.31:9000",
  // baseURL: "http://192.168.150.166:9000",
  // baseURL: "http://192.168.35.103:9000",
  headers: { "Content-Type": "application/json; charset=utf-8" },
});
// ✅ 여기서 interceptor 붙이기
server.interceptors.request.use(
  (config) => {
    const header = authHeader(); // { Authorization: "Bearer ..." } 또는 {}
    config.headers = { ...config.headers, ...header };
    return config;
  },
  (error) => Promise.reject(error)
);

// =======================
// ✅ Response Interceptor
// =======================
// let isLoggingOut = false;

// server.interceptors.response.use(
//   (res) => res,
//   (error) => {
//     const status = error.response?.status;

//     if (status === 401 && !isLoggingOut) {
//       isLoggingOut = true;

//       alert("로그인이 만료되었습니다. 다시 로그인해주세요.");
//       localStorage.removeItem("userDvi");

//       // ✅ 이미 로그인 페이지면 push하지 않기
//       if (router.currentRoute.path !== "/login") {
//         router.replace("/login").catch(() => {}); // ✅ promise 에러 방지
//       }
//     }

//     return Promise.reject(error);
//   }
// );

export default server;